var _path, _path2, _path3, _path4, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgZscl = function SvgZscl(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.407 29.385h2.431v13.677c0 3.237 2.61 5.861 5.83 5.861H42.5V34.5l-5.031-5.115h9.124c3.115 0 4.59-3.862 2.277-5.959L30.403 6.683a6.773 6.773 0 0 0-9.15.037L3.11 23.445c-2.286 2.107-.803 5.94 2.298 5.94Z",
    fill: "url(#zscl_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.554 10.836a1.5 1.5 0 0 1 2.006.103l7 7 .104.115a1.5 1.5 0 0 1-2.11 2.11l-.115-.104-5.94-5.939-5.939 5.94a1.5 1.5 0 1 1-2.12-2.122l7-7 .114-.103Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: 11.281,
    y: 14,
    width: 50.719,
    height: 48
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(6px)",
      clipPath: "url(#zscl_svg__b)",
      height: "100%",
      width: "100%"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-figma-bg-blur-radius": 12,
    d: "M48.92 36.769c.44.762.44 1.7 0 2.462l-5.073 8.788a2.463 2.463 0 0 1-2.133 1.231H31.567c-.88 0-1.692-.47-2.132-1.231L24.36 39.23c-.44-.762-.44-1.7 0-2.462l5.074-8.788a2.463 2.463 0 0 1 2.132-1.231h10.147c.88 0 1.693.47 2.133 1.231l5.073 8.788Z",
    fill: "url(#zscl_svg__c)",
    stroke: "url(#zscl_svg__d)",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.924 35.8c-.075-.406-.593-.557-.886-.264l-2.477 2.47a.915.915 0 0 1-1.281 0l-1.272-1.273a.889.889 0 0 1 0-1.273l2.496-2.489c.292-.292.151-.81-.254-.886a4.614 4.614 0 0 0-4.154 1.273 4.58 4.58 0 0 0-1.16 4.6c.076.255.03.538-.16.727l-2.515 2.508a.905.905 0 0 0 0 1.273l1.282 1.272a.915.915 0 0 0 1.28 0l2.535-2.526a.726.726 0 0 1 .725-.17 4.614 4.614 0 0 0 4.579-1.17 4.584 4.584 0 0 0 1.262-4.072Z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "zscl_svg__a",
    x1: 26,
    y1: 4.923,
    x2: 26,
    y2: 48.923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42A3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#018DD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "zscl_svg__c",
    x1: 50,
    y1: 38,
    x2: 23.281,
    y2: 38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.05
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "zscl_svg__d",
    x1: 50,
    y1: 38,
    x2: 23.281,
    y2: 38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1CCF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1CCF9",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "zscl_svg__b",
    transform: "translate(-11.281 -14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.92 36.769c.44.762.44 1.7 0 2.462l-5.073 8.788a2.463 2.463 0 0 1-2.133 1.231H31.567c-.88 0-1.692-.47-2.132-1.231L24.36 39.23c-.44-.762-.44-1.7 0-2.462l5.074-8.788a2.463 2.463 0 0 1 2.132-1.231h10.147c.88 0 1.693.47 2.133 1.231l5.073 8.788Z"
  })))));
};

export default SvgZscl;